import {TypeVoid} from './TypeDefinition'

const KIND = {
    FUNC: 9001,
    VAR: 9002,
    PARAM: 9003,
    RET_VAR: 9004
}

function SymbolTable () {
    this._block = -1
    this._table = []
    this._displacement = 0
}

SymbolTable.prototype = {
    enterBlock () {
        this._block++
        this._displacement = 0
    },
    exitBlock () {
        let i = 0
        while (i < this._table.length) {
            if (this._table[i].getBlock() === this._block) {
                this._table.splice(i, 1)
            } else {
                i++
            }
        }
        this._block--
        this._displacement = 0
    },
    addElement (lexeme, kind, type, isExternal, token) {
        let item = new TableEntry(this._block, lexeme, kind, type, 0, isExternal, token)
        this._table.push(item)
    },
    addVariable (lexeme, type, token) {
        this.addElement(lexeme, KIND.VAR, type, false, token)
        this._displacement += 1
    },
    addReturnVariable (lexeme, type, token) {
        this.addElement(lexeme, KIND.RET_VAR, type, false, token)
        // this._displacement += type.getSize()
    },
    addParameter (lexeme, type, token) {
        this.addElement(lexeme, KIND.PARAM, type, false, token)
        // this._displacement += type.getSize()
    },
    addFunction (lexeme, returnType, isExternal, token) {
        this.addElement(lexeme, KIND.FUNC, returnType, isExternal, token)
    },
    addMethod (lexeme, isExternal, token) {
        this.addElement(lexeme, KIND.FUNC, TypeVoid(), isExternal, token)
    },
    hasElement (lexeme, searchUpwards, condition) {
        for (let item of this._table) {
            if ((searchUpwards || item.getBlock() === this._block) && item.getLexeme() === lexeme && item[condition]()) {
                return true
            }
        }
        return false
    },
    hasFunction (lexeme) {
        return this.hasElement(lexeme, true, 'isFunction')
    },
    hasMethod (lexeme) {
        return this.hasElement(lexeme, true, 'isMethod')
    },
    hasCallable (lexeme) {
        return this.hasElement(lexeme, true, 'isCallable')
    },
    hasVariable (lexeme) {
        return this.hasElement(lexeme, false, 'isVariable')
    },
    hasReturnVariable (lexeme) {
        return this.hasElement(lexeme, false, 'isReturnVariable')
    },
    hasParameter (lexeme) {
        return this.hasElement(lexeme, false, 'isParameter')
    },
    hasStorage (lexeme) {
        return this.hasElement(lexeme, false, 'isStorage')
    },
    getElement (lexeme, searchUpwards, condition) {
        for (let item of this._table) {
            if ((searchUpwards || item.getBlock() === this._block) && item.getLexeme() === lexeme && item[condition]()) {
                return item
            }
        }
        return false
    },
    getVariable (lexeme) {
        return this.getElement(lexeme, false, 'isVariable')
    },
    getReturnVariable (lexeme) {
        return this.getElement(lexeme, false, 'isReturnVariable')
    },
    getParameter (lexeme) {
        return this.getElement(lexeme, false, 'isParameter')
    },
    getStorage (lexeme) {
        return this.getElement(lexeme, false, 'isStorage')
    },
    getMethod (lexeme) {
        return this.getElement(lexeme, true, 'isMethod')
    },
    getFunction (lexeme) {
        return this.getElement(lexeme, true, 'isFunction')
    },
    getCallable (lexeme) {
        return this.getElement(lexeme, true, 'isCallable')
    },
    getCurrentDisplacement () {
        return this._displacement
    },
    incrementDisplacement (amount) {
        this._displacement += amount
    },
    listElements (searchUpwards, condition) {
        let items = []

        for (let item of this._table) {
            if ((searchUpwards || item.getBlock() === this._block) && item[condition]()) {
                items.push(item)
            }
        }

        return items
    },
    listVariables (lexeme) {
        return this.listElements(false, 'isVariable')
    },
    listParameters (lexeme) {
        return this.listElements(false, 'isParameter')
    },
    listMethods (lexeme) {
        return this.listElements(true, 'isMethod')
    },
    listFunctions (lexeme) {
        return this.listElements(true, 'isFunction')
    },
    listCallables (lexeme) {
        return this.listElements(true, 'isCallable')
    },
    _dump () {
        console.log(JSON.parse(JSON.stringify(this._table)))
    }
}

function FunctionParameter (lexeme, type, token) {
    this._lexeme = lexeme
    this._type = type
    this._displacement = 0
    this._token = token
}

FunctionParameter.prototype = {
    getLexeme () {
        return this._lexeme
    },
    getType () {
        return this._type
    },
    getToken () {
        return this._token
    }
}

function TEFunctionExtra () {
    this._params = []
}

TEFunctionExtra.prototype = {
    count () {
        return this._params.length
    },
    addParam (lexeme, type, token) {
        this._params.push(new FunctionParameter(lexeme, type, token))
    },
    hasParam (lexeme) {
        for (let p of this._params) {
            if (p.getLexeme() === lexeme) {
                return true
            }
        }
        return false
    },
    getParam (lexeme) {
        for (let p of this._params) {
            if (p.getLexeme() === lexeme) {
                return p
            }
        }
    },
    listParams () {
        return this._params
    }
}

function TableEntry (block, lexeme, kind, type, displacement, external, token) {
    this._block = block
    this._lexeme = lexeme
    this._kind = kind
    this._type = type
    this._displacement = displacement
    this._isMain = false
    this._external = external
    this._token = token
    if (kind === KIND.FUNC) {
        this._extra = new TEFunctionExtra()
    } else {
        this._extra = null
    }
}

TableEntry.prototype = {
    getBlock () {
        return this._block
    },
    getKind () {
        return this._kind
    },
    getLexeme () {
        return this._lexeme
    },
    isVariable () {
        return this._kind === KIND.VAR
    },
    isReturnVariable () {
        return this._kind === KIND.RET_VAR
    },
    isParameter () {
        return this._kind === KIND.PARAM
    },
    isStorage () {
        return this._kind === KIND.VAR || this._kind === KIND.PARAM || this._kind === KIND.RET_VAR
    },
    isFunction (kind) {
        return this._kind === KIND.FUNC && !this._type.isVoid()
    },
    isMethod (kind) {
        return this._kind === KIND.FUNC && this._type.isVoid()
    },
    isExternal () {
        return this._external
    },
    isCallable (kind) {
        return this._kind === KIND.FUNC
    },
    getType () {
        return this._type
    },
    setType (type) {
        this._type = type
    },
    getDisplacement () {
        return this._displacement
    },
    setDisplacement (displacement) {
        this._displacement = displacement
    },
    getExtra () {
        return this._extra
    },
    getToken () {
        return this._token
    },
    setAsMain () {
        this._isMain = true
    },
    isMain () {
        return this._isMain
    }
}

export default SymbolTable



// WEBPACK FOOTER //
// ./src/Core/Parser/SymbolTable.js